<template>
  <el-card class="my-card  individual-account-form" shadow="never">
    <el-steps :active="stepsActive" align-center finish-status="success">
      <el-step :title="$t('inputInfo')"></el-step>
      <el-step :title="$t('uploadImage')"></el-step>
      <el-step :title="$t('accomplish')"></el-step>
    </el-steps>

    <el-form
      :model="openAccountForm"
      ref="openAccountForm"
      :rules="rules"
      label-position="top"
      class="have-steps"
    >
      <!-- 第一步填写信息 -->
      <el-row :gutter="20" v-if="stepsActive === 0">
        <el-col :span="6">
          <el-form-item :label="$t('loginAccount')" prop="loginName">
            <el-input
              size="medium"
              v-model="openAccountForm.loginName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('loaginPassword')" prop="loginPassword">
            <el-input
              size="medium"
              v-model="openAccountForm.loginPassword"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('firstName')" prop="name">
            <el-input size="medium" v-model="openAccountForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('lastName')" prop="surname">
            <el-input
              size="medium"
              v-model="openAccountForm.surname"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="padding:0">
          <el-col :span="6">
            <el-form-item
              :label="$t('loginAccount') + `(${$t('finance')})`"
              prop="finLoginName"
            >
              <el-input
                size="medium"
                v-model="openAccountForm.finLoginName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('loaginPassword') + `(${$t('finance')})`"
              prop="finLoginPassword"
            >
              <el-input
                size="medium"
                v-model="openAccountForm.finLoginPassword"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('firstName')" prop="financeName">
              <el-input
                size="medium"
                v-model="openAccountForm.financeName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('lastName')" prop="financeSurname">
              <el-input
                size="medium"
                v-model="openAccountForm.financeSurname"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col :span="24" style="padding:0">
          <el-col :span="6">
            <el-form-item
              :label="$t('loginAccount') + `(${$t('manager')})`"
              prop="manLoginName"
            >
              <el-input
                size="medium"
                v-model="openAccountForm.manLoginName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('loaginPassword') + `(${$t('manager')})`"
              prop="manLoginPassword"
            >
              <el-input
                size="medium"
                v-model="openAccountForm.manLoginPassword"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('firstName')" prop="managerName">
              <el-input
                size="medium"
                v-model="openAccountForm.managerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('lastName')" prop="managerSurname">
              <el-input
                size="medium"
                v-model="openAccountForm.managerSurname"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('partnerName')" prop="partnerName">
            <el-input
              size="medium"
              v-model="openAccountForm.partnerName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('legalForm')" prop="legalForm">
            <el-input
              size="medium"
              v-model="openAccountForm.legalForm"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('registeredOfficeAddress')"
            prop="registeredOfficeAddress"
          >
            <el-input
              size="medium"
              v-model="openAccountForm.registeredOfficeAddress"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('registeredBusinessName')"
            prop="registeredBusinessName"
          >
            <el-input
              size="medium"
              v-model="openAccountForm.registeredBusinessName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('idNumber')"
            :prop="business.type == 6 ? '' : 'idCard'"
          >
            <el-input size="medium" v-model="openAccountForm.idCard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('sex')"
            :prop="business.type == 6 ? '' : 'gender'"
          >
            <el-select size="medium" v-model="openAccountForm.gender">
              <el-option :label="$t('sex1')" :value="1"></el-option>
              <el-option :label="$t('sex0')" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('phone')" prop="phoneNo">
            <el-input
              size="medium"
              v-model="openAccountForm.phoneNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('maritalStatus')"
            :prop="business.type == 6 ? '' : 'marryStatus'"
          >
            <el-select size="medium" v-model="openAccountForm.marryStatus">
              <el-option :label="$t('maritalStatus0')" :value="0"></el-option>
              <el-option :label="$t('maritalStatus1')" :value="1"></el-option>
              <el-option :label="$t('maritalStatus2')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              `${$t('homeCountry')} / ${$t('provincial')} / ${$t('city')}`
            "
            prop="country_region_city"
          >
            <el-cascader
              size="medium"
              v-model="openAccountForm.country_region_city"
              :options="countryTree"
              :props="format"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('detailedAddress')" prop="address">
            <el-input
              size="medium"
              v-model="openAccountForm.address"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="business.type == 6">
          <el-form-item :label="$t('businessLicenseCode')">
            <el-input
              size="medium"
              v-model="openAccountForm.businessLicenseNo"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('uniekeId')" prop="phoneId">
            <el-input
              size="medium"
              v-model="openAccountForm.phoneId"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('alternatePhone')" prop="phoneNoBak1">
            <el-input
              size="medium"
              v-model="openAccountForm.phoneNoBak1"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('alternatePhone')" prop="phoneNoBak2">
            <el-input
              size="medium"
              v-model="openAccountForm.phoneNoBak2"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('remark')" prop="remark">
            <el-input size="medium" v-model="openAccountForm.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二步上传图片 -->
      <el-row :gutter="20" v-if="stepsActive === 1">
        <el-col :span="8">
          <el-form-item :label="$t('idCardFront')" prop="idImgFront">
            <upload-img
              :success-callback="idImageFrontSuccess"
              :delete-callback="idImageFrontDelete"
              :imgurl="openAccountForm.idImg"
            />
            <el-input
              size="medium"
              type="hidden"
              v-model="openAccountForm.idImgFront"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('idCardBack')" prop="idImgBack">
            <upload-img
              :success-callback="idImageBackSuccess"
              :delete-callback="idImageBackDelete"
              :imgurl="openAccountForm.idImg"
            />
            <el-input
              size="medium"
              type="hidden"
              v-model="openAccountForm.idImgBack"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('businessLicense')"
            prop="businessLicensePic"
          >
            <upload-img
              :success-callback="blpSuccess"
              :delete-callback="blpDelete"
              :imgurl="openAccountForm.businessLicensePic"
            />
            <el-input
              size="medium"
              type="hidden"
              v-model="openAccountForm.businessLicensePic"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="stepsActive >= 3" class="accomplish">
        <!-- 成功 -->
        <el-progress
          type="circle"
          v-if="stepsActive == 3"
          :stroke-width="10"
          :percentage="percentage"
          :width="200"
          status="success"
        ></el-progress>
        <div
          v-if="stepsActive == 3"
          style="text-align:center;color:#67C23A;font-size:34px"
        >
          {{ $t("operateSuccessfully") }}<br />
        </div>
        <!-- 失败 -->
        <el-progress
          type="circle"
          v-if="stepsActive == 4"
          :stroke-width="10"
          :percentage="percentage"
          :width="200"
          status="exception"
        ></el-progress>
        <div
          v-if="stepsActive == 4"
          style="text-align:center;color:#F56C6C;font-size:34px;line-height: 50px;"
        >
          {{ $t("operationFailure") }}<br />{{ failingMsg }}
        </div>
      </div>
    </el-form>

    <div class="bottom-button">
      <el-button
        size="medium"
        v-if="stepsActive > 0 && stepsActive < 2"
        @click="--stepsActive"
        >{{ $t("prevStep") }}</el-button
      >
      <el-button
        size="medium"
        v-if="stepsActive == 4"
        @click="stepsActive = 1"
        >{{ $t("prevStep") }}</el-button
      >
      <!-- <el-button size="medium" v-if="stepsActive<1&&stepsActive<2" @click="nextStep('openAccountForm')">{{$t('nextStep')}}</el-button>-->

      <el-button
        size="medium"
        v-if="stepsActive < 1 && stepsActive < 2"
        @click="validateForm('openAccountForm')"
        >{{ $t("nextStep") }}</el-button
      >
      <el-button
        size="medium"
        type="primary"
        v-if="stepsActive == 1"
        @click="submitForm('openAccountForm')"
        >{{ $t("submit") }}</el-button
      >
    </div>

    <!-- Dialog for data validation -->
    <el-dialog
      :title="$t('Validate Account Data')"
      :visible.sync="validationDialogVisible"
      width="600px"
    >
      <el-row :gutter="50">
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <strong>{{ $t("accountInfo") }}</strong>
            </el-col>
            <el-col :span="24">
              <label>{{ $t("loginAccount") }}:</label>
              {{ openAccountForm.loginName }}
            </el-col>
            <el-col :span="24" v-if="!openAccountForm.id">
              <label>{{ $t("loginPassword") }}:</label>
              {{ openAccountForm.loginPassword }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("firstName") }}:</label> {{ openAccountForm.name }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("lastName") }}:</label> {{ openAccountForm.surname }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("idNumber") }}:</label> {{ openAccountForm.idCard }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("sex") }}:</label>
              {{ openAccountForm.gender === 1 ? $t("sex1") : $t("sex0") }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("phone") }}:</label> {{ openAccountForm.phoneNo }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("maritalStatus") }}:</label>
              {{
                openAccountForm.marryStatus === 0
                  ? $t("maritalStatus0")
                  : openAccountForm.marryStatus === 1
                  ? $t("maritalStatus1")
                  : $t("maritalStatus2")
              }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("partnerName") }}:</label>
              {{ openAccountForm.partnerName }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("legalForm") }}:</label>
              {{ openAccountForm.legalForm }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("registeredOfficeAddress") }}:</label>
              {{ openAccountForm.registeredOfficeAddress }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("registeredBusinessName") }}:</label>
              {{ openAccountForm.registeredBusinessName }}
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <strong>{{ $t("location") }}</strong>
            </el-col>
            <el-col :span="24">
              <label>{{ $t("city") }}:</label>
              {{ formatRegionPays(countryRegionCity) }}
            </el-col>
            <el-col :span="24" v-if="business.type == 6">
              <label>{{ $t("businessLicenseCode") }}:</label>
              {{ openAccountForm.businessLicenseNo }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("address") }}:</label> {{ openAccountForm.address }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("uniekeId") }}:</label> {{ openAccountForm.phoneId }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("alternatePhone") }}:</label>
              {{ openAccountForm.phoneNoBak1 }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("alternatePhone") }}:</label>
              {{ openAccountForm.phoneNoBak2 }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("remark") }}:</label> {{ openAccountForm.remark }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="validationDialogVisible = false">{{
          $t("Cancel")
        }}</el-button>
        <el-button type="primary" @click="confirm('openAccountForm')">{{
          $t("confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import uploadImg from "@/components/uploadImg";
import verification from "@/assets/uilt/verification";
import customer from "@/api/customer";
export default {
  props: ["business"],
  components: { uploadImg },
  data() {
    return {
      stepsActive: 0,
      openAccountForm: {},
      failingMsg: "",
      percentage: 0,
      printParam: null,

      countryRegionCity: null,
      validationDialogVisible: false,
    };
  },
  computed: {
    rules() {
      let loginNameCheck = (rule, value, callback) => {
        if (!value || value.length < 1) {
          return callback(new Error(this.$t("requiredFields")));
        }
        this.loginNameCheck(value, callback);
      };
      let phoneNoCheck = (rule, value, callback) => {
        if (!value || value.length < 1) {
          return callback(new Error(this.$t("requiredFields")));
        }
        this.phoneNoCheck(value, callback);
      };

      let v = new verification(this);

      return {
        loginName: [
          { validator: loginNameCheck, required: true, trigger: "blur" },
        ],
        loginPassword: [
          { required: true, validator: v.password, trigger: "blur" },
        ],
        finLoginName: [
          { validator: loginNameCheck, required: true, trigger: "blur" },
        ],
        finLoginPassword: [
          { required: true, validator: v.password, trigger: "blur" },
        ],
        manLoginName: [
          { validator: loginNameCheck, required: true, trigger: "blur" },
        ],
        manLoginPassword: [
          { required: true, validator: v.password, trigger: "blur" },
        ],

        name: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        surname: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        financeName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        financeSurname: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        managerName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        managerSurname: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        partnerName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        legalForm: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        registeredOfficeAddress: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        registeredBusinessName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        phoneNo: [{ validator: phoneNoCheck, required: true, trigger: "blur" }],
        marryStatus: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        country_region_city: [
          {
            type: "array",
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        businessLicenseNo: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        idImgFront: [
          {
            required: true,
            message: this.$t("pleaseUploadPictures"),
            trigger: "blur",
          },
        ],
        idImgBack: [
          {
            required: true,
            message: this.$t("pleaseUploadPictures"),
            trigger: "blur",
          },
        ],
        businessLicensePic: [
          {
            required: true,
            message: this.$t("pleaseUploadPictures"),
            trigger: "blur",
          },
        ],
      };
    },
    format() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
  },
  watch: {
    /**在主账户前面增加字母分别自动填写财务、经理账户 */
    // "openAccountForm.loginName" (newValue) {
    //   this.openAccountForm.finLoginName = newValue ? "f" + JSON.parse(JSON.stringify(newValue)) : '';
    //   this.openAccountForm.manLoginName = newValue ? "m" + JSON.parse(JSON.stringify(newValue)) : '';
    // }
  },
  methods: {
    idImageFrontSuccess(imgurl) {
      console.log(imgurl);
      this.$set(this.openAccountForm, "idImgFront", imgurl);
    },
    idImageFrontDelete() {
      this.openAccountForm.idImg = "";
    },

    idImageBackSuccess(imgurl) {
      this.$set(this.openAccountForm, "idImgBack", imgurl);
    },
    idImageBackDelete() {
      this.openAccountForm.idImg = "";
    },

    blpSuccess(imgurl) {
      this.$set(this.openAccountForm, "businessLicensePic", imgurl);
    },
    blpDelete() {
      this.openAccountForm.businessLicensePic = "";
    },

    /**下一步时验证时候填写必填项 */
    nextStep(formName) {
      let _this = this;
      this.$refs[formName].validate(function(valid) {
        if (valid) ++_this.stepsActive;
        else return false;
      });
      this.validationDialogVisible = false;
    },

    confirm(formName) {
      let _this = this;
      _this.validationDialogVisible = false;
      this.$refs[formName].validate(function(valid) {
        if (valid) ++_this.stepsActive;
        else return false;
      });
    },

    formatRegionPays(region) {
      if (!region) return "";
      // Find the parent country in the countryList
      let p2 = this.countryList.find((c) => c.id == region);
      if (!p2) return ""; // Handle case where parent country is not found
      //console.log(p2.name);
      return p2.name; // Return the parent country name
    },
    // Validate the form and open the validation dialog
    validateForm(refName) {
      let _this = this;
      this.$refs[refName].validate(function(valid) {
        if (valid) {
          // Extract the value from country_region_city[2]
          let countryRegionCity2 = _this[refName].country_region_city[2];

          // Assign the value to the Vue component's property
          _this.countryRegionCity = countryRegionCity2;

          // Show the validation dialog
          _this.validationDialogVisible = true;

          // Log the value
          console.log("city : " + _this.countryRegionCity);
        } else {
          return false; // Stop if the form is invalid
        }
      });
    },
    submitForm(formName) {
      let _this = this;
      _this.validationDialogVisible = false;

      this.$refs[formName].validate(function(valid) {
        if (valid) {
          _this.stepsActive = 2;
          let crc = _this[formName].country_region_city;
          _this[formName].country = crc[0];
          _this[formName].region = crc[1];
          _this[formName].city = crc[2];
          _this[formName].idImg =
            _this[formName].idImgFront + "," + _this[formName].idImgBack;

          customer.addAccount({
            param: _this[formName],
            success: (res) => {
              if (res.code == 200) {
                _this.$message.success(_this.$t("success"));
                _this.stepsActive = 3;
              } else {
                _this.stepsActive = 4;
                _this.failingMsg = _this.$t(res.msg);
                _this.$message.warning(_this.$t("warning") + _this.$t(res.msg));
              }
              _this.percentage = 100;
            },
          });
        } else return false;
      });
    },
    /**检查手机号是否被注册 */
    phoneNoCheck(phoneNo, callback) {
      customer.checkCustomerPhoneNo({
        param: { phoneNo: phoneNo },
        success: (res) => {
          if (res.code != 200) return callback(new Error(this.$t(res.msg)));
          else return callback();
        },
      });
    },
    /**检查账户是否被注册 */
    loginNameCheck(loginName, callback) {
      customer.checkCustomerLoginName({
        param: { loginName: loginName },
        success: (res) => {
          if (res.code != 200) return callback(new Error(this.$t(res.msg)));
          else return callback();
        },
      });
    },
  },
  mounted() {
    this.openAccountForm = {
      businessCode: this.business.businessCode,
      type: this.business.type,
    };
  },
};
</script>

<style></style>
